import { createSelector } from '@ngrx/store'
import { AppState } from '../index'

export const selectThemeState = (state: AppState) => state.theme

const selectIsThemeDark = createSelector(selectThemeState, (state) => state.dark)

const selectIsThemeChrome = createSelector(selectThemeState, (state) => state.chrome)

const selectIsThemeLayerWireframe = createSelector(
  selectThemeState,
  (state) => state.layerWireframe,
)

const selectIsThemeUserCard = createSelector(selectThemeState, (state) => state.userCard)

const selectIsThemeLogoColor = createSelector(selectThemeState, (state) => state.logoColor)
